import { NotificationImportantOutlined } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { amber, green, grey, lightGreen, red } from "@mui/material/colors";
import { isArray, isEmpty, isNil, isObject, size } from "lodash";
import { useMemo } from "react";
import ChipItem from "../../../_src_shared/components/display/ChipItem";
import ExpandCollapseIconButton from "../../buttons/ExpandCollapseIconButton";
import Flx from "../../layout/Flx";
import RequiredDocumentCompletedProgressBar from "../../ui/progressBars/RequiredDocumentCompletedProgressBar";
import UnderwritingRequirementsCompletedProgressBar from "../../ui/progressBars/UnderwritingRequirementsCompletedProgressBar ";

const FinancingRequestHeader = ({
  loanName,
  loanProductType,
  loanPurpose,
  loan,
  open,
  setOpen,

  loanDocuments,
  modalTypeName,
}) => {
  return (
    <Box
      onClick={() => setOpen(!open)}
      sx={{
        display: "flex",
        flexDirection: "column",
        cursor: "pointer",
        position: "relative",
        gap: 1,
        m: -2,
        px: 2,
        pt: 2.5,
        pb: 1,
        transition: "background 100ms ease-in-out",

        "&:hover": {
          background: `linear-gradient(
        to bottom,
        ${grey[50]} 0%,
        ${open ? "transparent" : grey[50]} 100%
      )`,
        },
      }}
    >
      <Flx jw jb wrap ai={"flex-start"} g={1}>
        <Flx column g={0.5}>
          <Flx ac g={0.5} wrap>
            <Typography
              variant="h6"
              sx={{
                mr: 1,
                fontSize: "1.2em",
                fontWeight: 700,
                lineHeight: 1.3,
                color: "#0f172a",
                // mb: 0.3,
              }}
            >
              {loanName || "Untitled Loan"}
            </Typography>
            {/* <ActionRequiredChip loanDocuments={loanDocuments} /> */}
          </Flx>
          <Flx ac g={1.5} wrap sx={{ mb: 0.3 }}>
            <Typography
              variant="body2"
              sx={{
                fontSize: "0.85em",
                color: "#64748b",
              }}
            >
              {loanProductType}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontSize: "0.85em",
                color: "#64748b",
              }}
            >
              •
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontSize: "0.85em",
                color: "#64748b",
              }}
            >
              {loanPurpose}
            </Typography>
          </Flx>
        </Flx>

        <ActionRequiredChip loan={loan} />
      </Flx>

      <Flx ac g={0}>
        <UnderwritingRequirementsCompletedProgressBar
          loan={loan}
          // loanDocuments={loanDocuments}
        />

        <ExpandCollapseIconButton modalTypeName={modalTypeName} active={open} />
      </Flx>
    </Box>
  );
};
const ACTION_TYPES = {
  INCOMPLETE: "Missing Documents",
  ACTIVE_CONDITIONS: "Action Required",
  SUBMITTED_WAITING_REVIEW: "All Documents Submitted - Awaiting Review",
  SUBMITTED_ACCEPTED: "Completed & Accepted",
};

const ActionRequiredChip = ({ loan }) => {
  const filteredUnderwritingRequirements = useMemo(() => {
    const uwRequirements = loan?.underwritingRequirements;
    return (
      uwRequirements?.filter(
        (req) =>
          req?.status !== "Accepted" &&
          req?.docStipStatus !== "Received - Pending Review" &&
          req?.docStipStatus !== "Accepted",
      ) || []
    );
  }, [loan]);

  const hasRequirements = !isEmpty(filteredUnderwritingRequirements);

  if (!hasRequirements) {
    return;
  }
  return (
    <ChipItem
      color={red[900]}
      sx={{
        p: 1,
        borderRadius: 40,
        mb: 2,
        // mb: 0.5,
        flexShrink: 0,
        ".txt": {
          // fontSize: "13px",
          lineHeight: 1,
          fontWeight: 500,
        },
      }}
      icon={
        <NotificationImportantOutlined
          sx={{ mr: 0.4, ml: 0.4, fontSize: "16px !important" }}
          // className="thin"
        />
      }
      backgroundColor={red[50]}
      value={"Action Required"}
    />
  );
};
// const ActionRequiredChip = ({ loan }) => {
//   const text = useMemo(() => {
//     const requiredSize = 8;
//     const { loanDocuments, underwritingRequirements = [] } = loan;

//     if (!isEmpty(underwritingRequirements)) {
//       return ACTION_TYPES.ACTIVE_CONDITIONS;
//     }

//     if (isArray(loanDocuments)) {
//       if (
//         !isEmpty(loanDocuments?.filter((doc) => doc.docType === "Term Sheet"))
//       )
//         return ACTION_TYPES.ACTIVE_CONDITIONS;
//     }

//     return;
//     if (size(loanDocuments) < requiredSize) {
//       return ACTION_TYPES.INCOMPLETE;
//     }

//     if (size(loanDocuments) >= requiredSize) {
//       const filteredAccepted = loanDocuments?.filter(
//         (doc) => doc.documentStatus === "Accepted",
//       );
//       if (size(filteredAccepted) === requiredSize) {
//         return ACTION_TYPES.SUBMITTED_ACCEPTED;
//       }
//       return ACTION_TYPES.SUBMITTED_WAITING_REVIEW;
//     }
//   }, [loan]);

//   const styles = useMemo(() => {
//     let textColor = green[900];
//     let backgroundColor = lightGreen[50];
//     if (text === ACTION_TYPES.SUBMITTED_WAITING_REVIEW) {
//       textColor = "#0f172a";
//       backgroundColor = amber[100];
//     }
//     if (
//       text === ACTION_TYPES.INCOMPLETE ||
//       text === ACTION_TYPES.ACTIVE_CONDITIONS
//     ) {
//       textColor = red[900];
//       backgroundColor = red[50];
//     }
//     if (text === ACTION_TYPES.SUBMITTED_ACCEPTED) {
//       backgroundColor = green[100];
//     }
//     return {
//       color: textColor,
//       backgroundColor: backgroundColor,
//     };
//   }, [text]);

//   if (isNil(text)) {
//     return;
//   }
//   return (
//     <ChipItem
//       color={styles.color}
//       sx={{
//         p: 1,
//         borderRadius: 40,
//         mb: 2,
//         // mb: 0.5,
//         flexShrink: 0,
//         ".txt": {
//           // fontSize: "13px",
//           lineHeight: 1,
//           fontWeight: 500,
//         },
//       }}
//       icon={
//         <NotificationImportantOutlined
//           sx={{ mr: 0.4, ml: 0.4, fontSize: "16px !important" }}
//           // className="thin"
//         />
//       }
//       backgroundColor={styles.backgroundColor}
//       value={text}
//     />
//   );
// };

export default FinancingRequestHeader;
